const logoSrc = `${process.env.PUBLIC_URL}/assets/pargro-logo.jpg`;

function Logo({ compact = false }) {
  return (
    <img
      className={
        compact
          ? "block h-auto w-[158px] bg-white"
          : "block h-auto w-[235px] max-w-[80vw]"
      }
      src={logoSrc}
      alt="Pargro Investments Pvt. Ltd."
    />
  );
}

export default Logo;
